export default {
	filter: {
		pursh: {
			gys: [{
					name: '采购单号',
					Display: '采购订单号',
					dataType: 'text',
					type: 1
				},
				{
					name: '日期起',
					Display: '订单日期起',
					dataType: '日期',
					type: 3
				},
				{
					name: '日期止',
					Display: '订单日期止',
					dataType: '日期',
					type: 3
				},
				{
					name: '交付状态',
					Display: '交付状态',
					dataType: 'text',
					type: 2,
					valueName: 'valueName',
					displayName: 'displayName',
					dataSource: [{
							valueName: '',
							displayName: '全部'
						},
						{
							valueName: '未完成',
							displayName: '未完成'
						},
						{
							valueName: '完成',
							displayName: '完成'
						}
					]
				},
				{
					name: '物料编号',
					Display: '物料编码',
					dataType: 'text',
					type: 1
				},
				{
					name: '物料名称',
					Display: '物料名称',
					dataType: 'text',
					type: 1
				},
				{
					name: '规格型号',
					Display: '规格型号',
					dataType: 'text',
					type: 1
				},
				{
					name: '收料仓库',
					Display: '收料仓库',
					dataType: 'text',
					type: 1
				},
				{
					name: '确认状态',
					Display: '确认状态',
					dataType: 'text',
					type: 2,
					valueName: 'valueName',
					displayName: 'displayName',
					dataSource: [{
							valueName: '',
							displayName: '全部'
						},
						{
							valueName: '已确认',
							displayName: '已确认'
						},
						{
							valueName: '未确认',
							displayName: '未确认'
						}
					]
				},

				{
					name: '确认时间起',
					Display: '确认时间起',
					dataType: '日期',
					type: 3
				},
				{
					name: '确认时间止',
					Display: '确认时间止',
					dataType: '日期',
					type: 3
				}
			],
			main: [{
					name: '采购单号',
					Display: '采购订单号',
					dataType: 'text',
					type: 1
				},
				{
					name: '日期起',
					Display: '订单日期起',
					dataType: '日期',
					type: 3
				},
				{
					name: '日期止',
					Display: '订单日期止',
					dataType: '日期',
					type: 3
				},
				{
					name: '发布状态',
					Display: '发布状态',
					dataType: 'text',
					type: 2,
					valueName: 'valueName',
					displayName: 'displayName',
					dataSource: [{
							valueName: '',
							displayName: '全部'
						},
						{
							valueName: '已发布',
							displayName: '已发布'
						},
						{
							valueName: '未发布',
							displayName: '未发布'
						}
					]
				},
				{
					name: '供应商名称',
					Display: '供应商名称',
					dataType: 'text',
					type: 1,
					gys: false,
					cgy: true
				},
				{
					name: '物料编号',
					Display: '物料编码',
					dataType: 'text',
					type: 1
				},
				{
					name: '物料名称',
					Display: '物料名称',
					dataType: 'text',
					type: 1
				},
				{
					name: '规格型号',
					Display: '规格型号',
					dataType: 'text',
					type: 1
				},
				{
					name: '确认状态',
					Display: '确认状态',
					dataType: 'text',
					type: 2,
					valueName: 'valueName',
					displayName: 'displayName',
					dataSource: [{
							valueName: '',
							displayName: '全部'
						},
						{
							valueName: '已确认',
							displayName: '已确认'
						},
						{
							valueName: '未确认',
							displayName: '未确认'
						}
					]
				},
				{
					name: '制单人',
					Display: '制单人',
					dataType: 'text',
					type: 1
				},
				{
					name: '收料仓库',
					Display: '收料仓库',
					dataType: 'text',
					type: 1
				}
			]
		},
		transform: {
			gys: [{
					name: '采购单号',
					Display: '采购订单号',
					dataType: 'text',
					type: 1
				},
				{
					name: '采购日期起',
					Display: '订单日期起',
					dataType: '日期',
					type: 3
				},
				{
					name: '采购日期止',
					Display: '订单日期止',
					dataType: '日期',
					type: 3
				},
				{
					name: '_error',
					Display: '异常查询',
					dataType: 'text',
					type: 2,
					valueName: 'valueName',
					displayName: 'displayName',
					dataSource: [{
							valueName: '',
							displayName: '全部'
						},
						{
							valueName: 1,
							displayName: '异常'
						},
						{
							valueName: 0,
							displayName: '正常'
						}
					]
				},
				// {
				// 	name: '供应商名称',
				// 	Display: '供应商名称',
				// 	dataType: 'text',
				// 	type: 1
				// },

				{
					name: '物料编号',
					Display: '物料编码',
					dataType: 'text',
					type: 1
				},
				{
					name: '物料名称',
					Display: '物料名称',
					dataType: 'text',
					type: 1
				},
				{
					name: '规格型号',
					Display: '规格型号',
					dataType: 'text',
					type: 1
				},
				{
					Display: '',
					dataType: '',
					type: 9
				},
				{
					name: '到货日期起',
					Display: '到货日期起',
					dataType: '日期',
					type: 3
				},
				{
					name: '到货日期止',
					Display: '到货日期止',
					dataType: '日期',
					type: 3
				},
				{
					name: '收料仓库',
					Display: '收料仓库',
					dataType: 'text',
					type: 1
				},
				{
					name: '制单人',
					Display: '制单人',
					dataType: 'text',
					type: 1
				}

			],
			main: [{
					name: '采购单号',
					Display: '采购订单号',
					dataType: 'text',
					type: 1
				},
				{
					name: '采购日期起',
					Display: '订单日期起',
					dataType: '日期',
					type: 3
				},
				{
					name: '采购日期止',
					Display: '订单日期止',
					dataType: '日期',
					type: 3
				},
				{
					name: '_error',
					Display: '异常查询',
					dataType: 'text',
					type: 2,
					valueName: 'valueName',
					displayName: 'displayName',
					dataSource: [{
							valueName: '',
							displayName: '全部'
						},
						{
							valueName: 1,
							displayName: '异常'
						},
						{
							valueName: 0,
							displayName: '正常'
						}
					]
				},
				{
					name: '供应商名称',
					Display: '供应商名称',
					dataType: 'text',
					type: 1
				},
				{
					name: '物料编号',
					Display: '物料编码',
					dataType: 'text',
					type: 1
				},
				{
					name: '物料名称',
					Display: '物料名称',
					dataType: 'text',
					type: 1
				},
				{
					name: '规格型号',
					Display: '规格型号',
					dataType: 'text',
					type: 1
				},
				{
					name: '到货日期起',
					Display: '到货日期起',
					dataType: '日期',
					type: 3
				},
				{
					name: '到货日期止',
					Display: '到货日期止',
					dataType: '日期',
					type: 3
				},
				{
					name: '到货状态',
					Display: '到货状态',
					dataType: 'text',
					type: 2,
					valueName: 'valueName',
					displayName: 'displayName',
					dataSource: [{
							valueName: '',
							displayName: '全部'
						},
						{
							valueName: '未完成',
							displayName: '未完成'
						},
						{
							valueName: '已完成',
							displayName: '已完成'
						}
					]
				},
				{
					name: '收料仓库',
					Display: '收料仓库',
					dataType: 'text',
					type: 1
				},
				{
					name: '制单人',
					Display: '制单人',
					dataType: 'text',
					type: 1
				}

			]
		},
		asn: {
			gys: [{
					name: '采购单号',
					Display: '采购订单号',
					dataType: 'text',
					type: 1
				},
				{
					name: '联系人',
					Display: '联系人',
					dataType: 'text',
					type: 1
				},
				{
					name: '车牌号',
					Display: '车牌号',
					dataType: 'text',
					type: 1
				},
				{
					name: '物料标签是否打印',
					Display: '标签打印',
					dataType: 'text',
					type: 2,
					valueName: 'valueName',
					displayName: 'displayName',
					dataSource: [{
							valueName: '',
							displayName: '全部'
						},
						{
							valueName: '未打印',
							displayName: '未打印'
						},
						{
							valueName: '已打印',
							displayName: '已打印'
						}
					]
				},
				{
					name: '发运单是否打印',
					Display: '发运单打印',
					dataType: 'text',
					type: 2,
					valueName: 'valueName',
					displayName: 'displayName',
					dataSource: [{
							valueName: '',
							displayName: '全部'
						},
						{
							valueName: '未打印',
							displayName: '未打印'
						},
						{
							valueName: '已打印',
							displayName: '已打印'
						}
					]
				},
				{
					name: '物料编码',
					Display: '物料编码',
					dataType: 'text',
					type: 1
				},
				{
					name: '物料名称',
					Display: '物料名称',
					dataType: 'text',
					type: 1
				},
				{
					name: '规格型号',
					Display: '规格型号',
					dataType: 'text',
					type: 1
				},
				{
					name: '卸货仓库',
					Display: '收料仓库',
					dataType: 'text',
					type: 1
				},
				{
					name: 'ASN单号',
					Display: 'ASN单号',
					dataType: 'text',
					type: 1
				},
				{
					name: '到货日期起',
					Display: '到货日期起',
					dataType: '日期',
					type: 3
				},
				{
					name: '到货日期止',
					Display: '到货日期止',
					dataType: '日期',
					type: 3
				}
			],
			main: [{
					name: '采购单号',
					Display: '采购订单号',
					dataType: 'text',
					type: 1
				},
				{
					name: '联系人',
					Display: '联系人',
					dataType: 'text',
					type: 1
				},
				{
					name: '车牌号',
					Display: '车牌号',
					dataType: 'text',
					type: 1
				},
				{
					name: '物料标签是否打印',
					Display: '标签打印',
					dataType: 'text',
					type: 2,
					valueName: 'valueName',
					displayName: 'displayName',
					dataSource: [{
							valueName: '',
							displayName: '全部'
						},
						{
							valueName: '未打印',
							displayName: '未打印'
						},
						{
							valueName: '已打印',
							displayName: '已打印'
						}
					]
				},
				{
					name: '发运单是否打印',
					Display: '发运单打印',
					dataType: 'text',
					type: 2,
					valueName: 'valueName',
					displayName: 'displayName',
					dataSource: [{
							valueName: '',
							displayName: '全部'
						},
						{
							valueName: '未打印',
							displayName: '未打印'
						},
						{
							valueName: '已打印',
							displayName: '已打印'
						}
					]
				},
				{
					name: '供应商名称',
					Display: '供应商名称',
					dataType: 'text',
					type: 1
				},
				{
					name: '物料编码',
					Display: '物料编码',
					dataType: 'text',
					type: 1
				},
				{
					name: '物料名称',
					Display: '物料名称',
					dataType: 'text',
					type: 1
				},
				{
					name: '规格型号',
					Display: '规格型号',
					dataType: 'text',
					type: 1
				},
				{
					name: '卸货仓库',
					Display: '收料仓库',
					dataType: 'text',
					type: 1
				},
				{
					name: 'ASN单号',
					Display: 'ASN单号',
					dataType: 'text',
					type: 1
				},
				{
					name: '到货日期起',
					Display: '到货日期起',
					dataType: '日期',
					type: 3
				},
				{
					name: '到货日期止',
					Display: '到货日期止',
					dataType: '日期',
					type: 3
				},
				{
					name: '作废状态',
					Display: '作废状态',
					dataType: 'text',
					type: 2,
					valueName: 'valueName',
					displayName: 'displayName',
					dataSource: [{
							valueName: '',
							displayName: '全部'
						},
						{
							valueName: '未作废',
							displayName: '未作废'
						},
						{
							valueName: '已作废',
							displayName: '已作废'
						}
					]
				},
				{
					name: '作废人',
					Display: '作废人',
					dataType: 'text',
					type: 1
				}
			]
		},
		userInfoList: {
			main: [{
					name: 'FName',
					Display: '姓名',
					dataType: 'text',
					type: 1,
					disabled: true
				},
				{
					name: 'FEmail',
					Display: '邮箱',
					dataType: 'text',
					type: 1,
					disabled: true
				},
				{
					name: 'FSex',
					Display: '性别',
					dataType: 'text',
					disabled: true,
					type: 2,
					valueName: 'valueName',
					displayName: 'displayName',
					dataSource: [{
							valueName: '女',
							displayName: '女'
						},
						{
							valueName: '男',
							displayName: '男'
						}
					]
				},
				{
					name: 'FZW',
					Display: '职务',
					dataType: 'text',
					disabled: true,
					type: 1
				},
				{
					name: 'FMoilePhone',
					Display: '手机号码',
					dataType: 'text',
					disabled: true,
					type: 1
				},
				{
					name: 'FPhone',
					Display: '电话号',
					dataType: 'text',
					disabled: true,
					type: 1
				}
			],
			update: [{
					name: 'FName',
					Display: '姓名',
					dataType: 'text',
					type: 1
				},
				{
					name: 'FEmail',
					Display: '邮箱',
					dataType: 'text',
					type: 1
				},
				{
					name: 'FSex',
					Display: '性别',
					dataType: 'text',
					type: 2,
					valueName: 'valueName',
					displayName: 'displayName',
					dataSource: [{
							valueName: '女',
							displayName: '女'
						},
						{
							valueName: '男',
							displayName: '男'
						}
					]
				},
				{
					name: 'FZW',
					Display: '职务',
					dataType: 'text',
					type: 1
				},
				{
					name: 'FMoilePhone',
					Display: '手机号码',
					dataType: 'text',
					type: 1
				},
				{
					name: 'FPhone',
					Display: '电话号',
					dataType: 'text',
					type: 1
				}
			],
			Pass: [{
					name: 'old',
					Display: '旧密码',
					dataType: 'password',
					must: true,
					type: 1
				},
				{
					name: 'repass',
					Display: '新密码',
					dataType: 'password',
					must: true,
					type: 1
				},
				{
					name: 'recheckpass',
					Display: '确认密码',
					dataType: 'password',
					must: true,
					type: 1
				},
			]
		},
		report: {
			DZ: [{
					"Display": "采购订单号",
					"name": "#fbillno#",
					"dataType": "text",
					"type": 1
				},
				{
					"Display": "物料编号",
					"name": "#fitemnumber#",
					"dataType": "text",
					"type": 1
				},
				{
					"Display": "物料名称",
					"name": "#fitemname#",
					"dataType": "text",
					"type": 1
				},
				{
					"Display": "规格型号",
					"name": "#ggxh#",
					"dataType": "text",
					"type": 1
				},
				{
					"Display": "入库单号",
					"name": "#frkbillno#",
					"dataType": "text",
					"type": 1
				},
				{
					"Display": "入库日期起",
					"name": "#frkdatefrom#",
					"dataType": "日期",
					"type": 3
				},
				{
					"Display": "入库日期止",
					"name": "#frkdateto#",
					"dataType": "日期",
					"type": 3
				},
				{
					"Display": "应付单号",
					"name": "#yf#",
					"dataType": "text",
					"type": 1
				},
				{
					"Display": "供应商名称",
					"name": "#fgysname#",
					"dataType": "text",
					"type": 1
				}
				
				
			]

		}
	},
	header: {
		pursh: {
			main: [{
					name: '日期',
					field: '日期', //grid
					title: '日期',
					width: 80,
					fix: '',
					contentTip: true,
					must: false,
					edit: false,
					hide: false,
					valueType: 'DateTime'
				},
				{
					name: '采购单号',
					field: '采购单号', //grid
					title: '采购单号',
					width: 80,
					fix: '',
					contentTip: true,
					must: false,
					edit: false,
					hide: false,
					valueType: 'String'
				},
				{
					name: '行号',
					field: '行号', //grid
					title: '行号',
					width: 80,
					fix: '',
					contentTip: true,
					must: false,
					edit: false,
					hide: false,
					valueType: 'Int'
				},
				{
					name: '供应商名称',
					field: '供应商名称', //grid
					title: '供应商名称',
					width: 80,
					fix: '',
					contentTip: true,
					must: false,
					edit: false,
					hide: false,
					valueType: 'String'
				},
				{
					name: '供应商编号',
					field: '供应商编号', //grid
					title: '供应商编号',
					width: 80,
					fix: '',
					contentTip: true,
					must: false,
					edit: false,
					hide: false,
					valueType: 'String'
				},
				{
					name: '物料编码',
					field: '物料编码', //grid
					title: '物料编码',
					width: 80,
					fix: '',
					contentTip: true,
					must: false,
					edit: false,
					hide: false,
					valueType: 'String'
				},
				{
					name: '物料名称',
					field: '物料名称', //grid
					title: '物料名称',
					width: 80,
					fix: '',
					contentTip: true,
					must: false,
					edit: false,
					hide: false,
					valueType: 'String'
				},
				{
					name: '规格型号',
					field: '规格型号', //grid
					title: '规格型号',
					width: 80,
					fix: '',
					contentTip: true,
					must: false,
					edit: false,
					hide: false,
					valueType: 'String'
				},
				{
					name: '单位',
					field: '单位', //grid
					title: '单位',
					width: 80,
					fix: '',
					contentTip: true,
					must: false,
					edit: false,
					hide: false,
					valueType: 'String'
				},
				{
					name: '数量',
					field: '数量', //grid
					title: '数量',
					width: 80,
					fix: '',
					contentTip: true,
					must: false,
					edit: false,
					hide: false,
					valueType: 'String'
				},
				{
					name: '发布状态',
					field: '发布状态', //grid
					title: '发布状态',
					width: 80,
					fix: '',
					contentTip: true,
					must: false,
					edit: false,
					hide: false,
					valueType: 'String'
				},
				{
					name: '确认状态',
					field: '确认状态', //grid
					title: '确认状态',
					width: 80,
					fix: '',
					contentTip: true,
					must: false,
					edit: false,
					hide: false,
					valueType: 'String'
				},
				{
					name: 'N+3',
					field: 'N+3', //grid
					title: 'N+3',
					width: 80,
					fix: '',
					contentTip: true,
					must: false,
					edit: false,
					hide: false,
					valueType: 'String'
				},

				{
					name: 'EOP', //EOP（日期
					field: 'EOP', //grid
					title: 'EOP',
					width: 80,
					fix: '',
					contentTip: true,
					must: false,
					edit: false,
					hide: false,
					valueType: 'DateTime'
				},
				{
					name: '收料仓库', //已签核/未签核
					field: '收料仓库', //grid
					title: '收料仓库',
					width: 80,
					fix: '',
					contentTip: true,
					must: false,
					edit: false,
					hide: false,
					valueType: 'String',
				},
				{
					name: '收货地址', //已签核/未签核
					field: '收货地址', //grid
					title: '收货地址',
					width: 80,
					fix: '',
					contentTip: true,
					must: false,
					edit: false,
					hide: false,
					valueType: 'String',

				}
			],
			report1: [{
					name: '日期',
					field: '日期', //grid
					title: '日期',
					width: 80,
					fix: '',
					contentTip: true,
					must: false,
					edit: false,
					hide: false,
					valueType: 'DateTime'
				},
				{
					name: '采购单号',
					field: '采购单号', //grid
					title: '采购单号',
					width: 80,
					fix: '',
					contentTip: true,
					must: false,
					edit: false,
					hide: false,
					valueType: 'String'
				},
				{
					name: '行号',
					field: '行号', //grid
					title: '行号',
					width: 80,
					fix: '',
					contentTip: true,
					must: false,
					edit: false,
					hide: false,
					valueType: 'Int'
				},
				{
					name: '供应商编号',
					field: '供应商编号', //grid
					title: '供应商编号',
					width: 80,
					fix: '',
					contentTip: true,
					must: false,
					edit: false,
					hide: false,
					valueType: 'String'
				},
				{
					name: '供应商名称',
					field: '供应商名称', //grid
					title: '供应商名称',
					width: 80,
					fix: '',
					contentTip: true,
					must: false,
					edit: false,
					hide: false,
					valueType: 'String'
				},
				{
					name: '物料编码',
					field: '物料编码', //grid
					title: '物料编码',
					width: 80,
					fix: '',
					contentTip: true,
					must: false,
					edit: false,
					hide: false,
					valueType: 'String'
				},
				{
					name: '物料名称',
					field: '物料名称', //grid
					title: '物料名称',
					width: 80,
					fix: '',
					contentTip: true,
					must: false,
					edit: false,
					hide: false,
					valueType: 'String'
				},
				{
					name: '规格型号',
					field: '规格型号', //grid
					title: '规格型号',
					width: 80,
					fix: '',
					contentTip: true,
					must: false,
					edit: false,
					hide: false,
					valueType: 'String'
				},
				{
					name: '单位',
					field: '单位', //grid
					title: '单位',
					width: 80,
					fix: '',
					contentTip: true,
					must: false,
					edit: false,
					hide: false,
					valueType: 'String'
				},
				{
					name: '数量',
					field: '数量', //grid
					title: '数量',
					width: 80,
					fix: '',
					contentTip: true,
					must: false,
					edit: false,
					hide: false,
					valueType: 'String'
				},
				{
					name: '发布状态',
					field: '发布状态', //grid
					title: '发布状态',
					width: 80,
					fix: '',
					contentTip: true,
					must: false,
					edit: false,
					hide: false,
					valueType: 'String'
				},
				{
					name: '确认状态',
					field: '确认状态', //grid
					title: '确认状态',
					width: 80,
					fix: '',
					contentTip: true,
					must: false,
					edit: false,
					hide: false,
					valueType: 'String'
				},
				{
					name: 'N+1',
					field: 'N+1', //grid
					title: 'N+1',
					width: 80,
					fix: '',
					contentTip: true,
					must: false,
					edit: false,
					hide: false,
					valueType: 'String'
				},
				{
					name: 'N+2',
					field: 'N+2', //grid
					title: 'N+2',
					width: 80,
					fix: '',
					contentTip: true,
					must: false,
					edit: false,
					hide: false,
					valueType: 'String'
				},
				{
					name: 'N+3',
					field: 'N+3', //grid
					title: 'N+3',
					width: 80,
					fix: '',
					contentTip: true,
					must: false,
					edit: false,
					hide: false,
					valueType: 'String'
				},
				{
					name: 'N+3',
					field: 'N+3', //grid
					title: 'N+3',
					width: 80,
					fix: '',
					contentTip: true,
					must: false,
					edit: false,
					hide: false,
					valueType: 'String'
				},

				{
					name: 'EOP', //EOP（日期
					field: 'EOP', //grid
					title: 'EOP',
					width: 80,
					fix: '',
					contentTip: true,
					must: false,
					edit: false,
					hide: false,
					valueType: 'DateTime'
				},
				{
					name: '收料仓库', //已签核/未签核
					field: '收料仓库', //grid
					title: '收料仓库',
					width: 80,
					fix: '',
					contentTip: true,
					must: false,
					edit: false,
					hide: false,
					valueType: 'String',
				},
				{
					name: '前三个月平均用量', //已签核/未签核
					field: '前三个月平均用量', //grid
					title: '前三个月平均用量',
					width: 80,
					fix: '',
					contentTip: true,
					must: false,
					edit: false,
					hide: false,
					valueType: 'String',

				}
			],
			report2: [{
					name: '日期',
					field: '日期', //grid
					title: '日期',
					width: 80,
					fix: '',
					contentTip: true,
					must: false,
					edit: false,
					hide: false,
					valueType: 'DateTime'
				},
				{
					name: '采购单号',
					field: '采购单号', //grid
					title: '采购单号',
					width: 80,
					fix: '',
					contentTip: true,
					must: false,
					edit: false,
					hide: false,
					valueType: 'String'
				},
				{
					name: '行号',
					field: '行号', //grid
					title: '行号',
					width: 80,
					fix: '',
					contentTip: true,
					must: false,
					edit: false,
					hide: false,
					valueType: 'Int'
				},
				{
					name: '供应商编号',
					field: '供应商编号', //grid
					title: '供应商编号',
					width: 80,
					fix: '',
					contentTip: true,
					must: false,
					edit: false,
					hide: false,
					valueType: 'String'
				},
				{
					name: '供应商名称',
					field: '供应商名称', //grid
					title: '供应商名称',
					width: 80,
					fix: '',
					contentTip: true,
					must: false,
					edit: false,
					hide: false,
					valueType: 'String'
				},
				{
					name: '物料编码',
					field: '物料编码', //grid
					title: '物料编码',
					width: 80,
					fix: '',
					contentTip: true,
					must: false,
					edit: false,
					hide: false,
					valueType: 'String'
				},
				{
					name: '物料名称',
					field: '物料名称', //grid
					title: '物料名称',
					width: 80,
					fix: '',
					contentTip: true,
					must: false,
					edit: false,
					hide: false,
					valueType: 'String'
				},
				{
					name: '规格型号',
					field: '规格型号', //grid
					title: '规格型号',
					width: 80,
					fix: '',
					contentTip: true,
					must: false,
					edit: false,
					hide: false,
					valueType: 'String'
				},
				{
					name: '单位',
					field: '单位', //grid
					title: '单位',
					width: 80,
					fix: '',
					contentTip: true,
					must: false,
					edit: false,
					hide: false,
					valueType: 'String'
				},
				{
					name: '数量',
					field: '数量', //grid
					title: '数量',
					width: 80,
					fix: '',
					contentTip: true,
					must: false,
					edit: false,
					hide: false,
					valueType: 'String'
				},
				{
					name: '到货日期',
					field: '到货日期', //grid
					title: '到货日期',
					width: 80,
					fix: '',
					contentTip: true,
					must: false,
					edit: false,
					hide: false,
					valueType: 'DateTime'
				},
				{
					name: '到货数量',
					field: '到货数量', //grid
					title: '到货数量',
					width: 80,
					fix: '',
					contentTip: true,
					must: false,
					edit: false,
					hide: false,
					valueType: 'Int'
				},
				{
					name: 'ASN单号',
					field: 'ASN单号', //grid
					title: 'ASN单号',
					width: 80,
					fix: '',
					contentTip: true,
					must: false,
					edit: false,
					hide: false,
					valueType: 'String'
				},
				{
					name: 'ASN数量',
					field: 'ASN数量', //grid
					title: 'ASN数量',
					width: 80,
					fix: '',
					contentTip: true,
					must: false,
					edit: false,
					hide: false,
					valueType: 'Int'
				},
				{
					name: '到货数量签核', //状态：已签核/未签核）
					field: '到货数量签核', //grid
					title: '到货数量签核',
					width: 80,
					fix: '',
					contentTip: true,
					must: false,
					edit: false,
					hide: false,
					valueType: 'String'
				},
				{
					name: '入库日期',
					field: '入库日期', //grid
					title: '入库日期',
					width: 80,
					fix: '',
					contentTip: true,
					must: false,
					edit: false,
					hide: false,
					valueType: 'DateTime'
				},

				{
					name: '入库数量', //EOP（日期
					field: '入库数量', //grid
					title: '入库数量',
					width: 80,
					fix: '',
					contentTip: true,
					must: false,
					edit: false,
					hide: false,
					valueType: 'Int'
				}
			]
		}
	},
	testData: {
		pursh: {
			main: [{
					'_error': true,
					'_id': 1,
					'日期': new Date(),
					'采购单号': 'test00000001',
					'行号': '1',
					'供应商编号': 'G00001',
					'供应商名称': 'Test',
					'物料编号': '1ede1',
					'物料名称': '1dwe1',
					'规格型号': '1cwf1',
					'单位': 'pcs',
					'数量': 1000,
					'发布状态': '未发布',
					'确认状态': '未确认',
					'N+3': '',
					'EOP': new Date(),
					'收料仓库': '001',
					'收货地址': '暂定从erp中带过来'
				},
				{
					'_error': false,
					'_id': 2,
					'日期': new Date(),
					'采购单号': 'test00000001',
					'行号': '1',
					'供应商编号': 'G00001',
					'供应商名称': 'Test',
					'物料编号': '1ede1',
					'物料名称': '1dwe1',
					'规格型号': '1cwf1',
					'单位': 'pcs',
					'数量': 1000,
					'发布状态': '未发布',
					'确认状态': '未确认',
					'N+3': '',
					'EOP': new Date(),
					'收料仓库': '001',
					'收货地址': '暂定从erp中带过来'
				},
				{
					'_error': false,
					'_id': 3,
					'日期': new Date(),
					'采购单号': 'test00000001',
					'行号': '1',
					'供应商编号': 'G00001',
					'供应商名称': 'Test',
					'物料编号': '1ede1',
					'物料名称': '1dwe1',
					'规格型号': '1cwf1',
					'单位': 'pcs',
					'数量': 1000,
					'发布状态': '未发布',
					'确认状态': '未确认',
					'N+3': '',
					'EOP': new Date(),
					'收料仓库': '001',
					'收货地址': '暂定从erp中带过来'
				},
				{
					'_error': false,
					'_id': 4,
					'日期': new Date(),
					'采购单号': 'test00000001',
					'行号': '1',
					'供应商编号': 'G00001',
					'供应商名称': 'Test',
					'物料编号': '1ede1',
					'物料名称': '1dwe1',
					'规格型号': '1cwf1',
					'单位': 'pcs',
					'数量': 1000,
					'发布状态': '未发布',
					'确认状态': '未确认',
					'N+3': '',
					'EOP': new Date(),
					'收料仓库': '001',
					'收货地址': '暂定从erp中带过来'
				},
				{
					'_error': false,
					'_id': 5,
					'日期': new Date(),
					'采购单号': 'test00000001',
					'行号': '1',
					'供应商编号': 'G00001',
					'供应商名称': 'Test',
					'物料编号': '1ede1',
					'物料名称': '1dwe1',
					'规格型号': '1cwf1',
					'单位': 'pcs',
					'数量': 1000,
					'发布状态': '未发布',
					'确认状态': '未确认',
					'N+3': '',
					'EOP': new Date(),
					'收料仓库': '001',
					'收货地址': '暂定从erp中带过来'
				},
				{
					'_error': false,
					'_id': 6,
					'日期': new Date(),
					'采购单号': 'test00000001',
					'行号': '1',
					'供应商编号': 'G00001',
					'供应商名称': 'Test',
					'物料编号': '1ede1',
					'物料名称': '1dwe1',
					'规格型号': '1cwf1',
					'单位': 'pcs',
					'数量': 1000,
					'发布状态': '未发布',
					'确认状态': '未确认',
					'N+3': '',
					'EOP': new Date(),
					'收料仓库': '001',
					'收货地址': '暂定从erp中带过来'
				},
				{
					'_error': false,
					'_id': 7,
					'日期': new Date(),
					'采购单号': 'test00000001',
					'行号': '1',
					'供应商编号': 'G00001',
					'供应商名称': 'Test',
					'物料编号': '1ede1',
					'物料名称': '1dwe1',
					'规格型号': '1cwf1',
					'单位': 'pcs',
					'数量': 1000,
					'发布状态': '未发布',
					'确认状态': '未确认',
					'N+3': '',
					'EOP': new Date(),
					'收料仓库': '001',
					'收货地址': '暂定从erp中带过来'
				},
				{
					'_error': false,
					'_id': 8,
					'日期': new Date(),
					'采购单号': 'test00000001',
					'行号': '1',
					'供应商编号': 'G00001',
					'供应商名称': 'Test',
					'物料编号': '1ede1',
					'物料名称': '1dwe1',
					'规格型号': '1cwf1',
					'单位': 'pcs',
					'数量': 1000,
					'发布状态': '未发布',
					'确认状态': '未确认',
					'N+3': '',
					'EOP': new Date(),
					'收料仓库': '001',
					'收货地址': '暂定从erp中带过来'
				},
				{
					'_error': false,
					'_id': 9,
					'日期': new Date(),
					'采购单号': 'test00000001',
					'行号': '1',
					'供应商编号': 'G00001',
					'供应商名称': 'Test',
					'物料编号': '1ede1',
					'物料名称': '1dwe1',
					'规格型号': '1cwf1',
					'单位': 'pcs',
					'数量': 1000,
					'发布状态': '未发布',
					'确认状态': '未确认',
					'N+3': '',
					'EOP': new Date(),
					'收料仓库': '001',
					'收货地址': '暂定从erp中带过来'
				},
				{
					'_error': false,
					'_id': 10,
					'日期': new Date(),
					'采购单号': 'test00000001',
					'行号': '1',
					'供应商编号': 'G00001',
					'供应商名称': 'Test',
					'物料编号': '1ede1',
					'物料名称': '1dwe1',
					'规格型号': '1cwf1',
					'单位': 'pcs',
					'数量': 1000,
					'发布状态': '未发布',
					'确认状态': '未确认',
					'N+3': '',
					'EOP': new Date(),
					'收料仓库': '001',
					'收货地址': '暂定从erp中带过来'
				},
				{
					'_error': false,
					'_id': 11,
					'日期': new Date(),
					'采购单号': 'test00000001',
					'行号': '1',
					'供应商编号': 'G00001',
					'供应商名称': 'Test',
					'物料编号': '1ede1',
					'物料名称': '1dwe1',
					'规格型号': '1cwf1',
					'单位': 'pcs',
					'数量': 1000,
					'发布状态': '未发布',
					'确认状态': '未确认',
					'N+3': '',
					'EOP': new Date(),
					'收料仓库': '001',
					'收货地址': '暂定从erp中带过来'
				},
				{
					'_error': false,
					'_id': 12,
					'日期': new Date(),
					'采购单号': 'test00000001',
					'行号': '1',
					'供应商编号': 'G00001',
					'供应商名称': 'Test',
					'物料编号': '1ede1',
					'物料名称': '1dwe1',
					'规格型号': '1cwf1',
					'单位': 'pcs',
					'数量': 1000,
					'发布状态': '未发布',
					'确认状态': '未确认',
					'N+3': '',
					'EOP': new Date(),
					'收料仓库': '001',
					'收货地址': '暂定从erp中带过来'
				}
			]
		}
	},
	DHAddTableHead: {
		main: [{
				name: '采购单号',
				Display: '采购单号',
				dataType: 'text',
				type: 1,
				disabled: true
			},
			{
				name: '采购行号',
				Display: '采购行号',
				dataType: 'text',
				type: 1,
				disabled: true
			},
			{
				name: '物料编号',
				Display: '物料编号',
				dataType: 'text',
				type: 1,
				disabled: true
			}, {
				name: '物料名称',
				Display: '物料名称',
				dataType: 'text',
				type: 1,
				disabled: true
			}, {
				name: '供应商编号',
				Display: '供应商编号',
				dataType: 'text',
				type: 1,
				disabled: true
			},
			{
				name: '供应商名称',
				Display: '供应商名称',
				dataType: 'text',
				type: 1,
				disabled: true
			},
			{
				name: '剩余计划到货数量',
				Display: '剩余计划到货',
				dataType: 'text',
				type: 1,
				disabled: true
			},
			{
				name: '到货数量',
				Display: '计划到货数量',
				dataType: 'number',
				must: true,
				type: 1,
			},
			{
				name: '到货日期',
				Display: '到货日期',
				dataType: '日期',
				must: true,
				type: 3,
			},
		],
		updateItem: [{
				name: '到货数量',
				Display: '计划到货数量',
				dataType: 'number',
				must: true,
				type: 1,
			},
			{
				name: '到货日期',
				Display: '到货日期',
				dataType: '日期',
				must: true,
				type: 3,
			},
			{
				name: '修改类型',
				Display: '修改类型',
				dataType: 'text',
				must: true,
				type: 2,
				valueName: 'valueName',
				displayName: 'displayName',
				dataSource: [{
						valueName: '正常月计划',
						displayName: '正常月计划'
					},
					{
						valueName: '客户订单变化变更',
						displayName: '客户订单变化变更'
					},
					{
						valueName: '漏下、错下申请变更',
						displayName: '漏下、错下申请变更'
					},
					{
						valueName: '生产质量报废变更',
						displayName: '生产质量报废变更'
					},
					{
						valueName: '节假日提前备库变更',
						displayName: '节假日提前备库变更'
					},
					{
						valueName: '前期交接引起的变更',
						displayName: '前期交接引起的变更'
					},
					{
						valueName: '周计划订单“仅包材”',
						displayName: '周计划订单“仅包材”'
					}
				]
			},
		],
		deleteItem: [{
			name: '删除原因',
			Display: '删除原因',
			dataType: 'text',
			must: true,
			type: 1,
		}]
	},
	ANS: {
		add: [{
				name: 'ASN日期',
				Display: 'ASN日期',
				dataType: '日期',
				type: 3,
				must: true,
				disabled: true
			},
			{
				name: 'ASN单号',
				Display: 'ASN单号',
				dataType: 'text',
				type: 1,
				disabled: true
			},
			{
				name: '交付日期',
				Display: '交付日期',
				dataType: '日期',
				type: 3,
			},
			{
				name: '车牌号',
				Display: '车牌号',
				dataType: 'text',
				type: 1,
				must: true
			},
			{
				name: '预计到货时间',
				Display: '预计到货时间',
				dataType: '日期',
				dateTime:{
					format:'yyyy-MM-dd HH:mm',
					type:'datetime'
				},
				type: 3,
				must: true
			},
			{
				name: '联系人',
				Display: '联系人',
				dataType: 'text',
				type: 1,
				must: true,
			},
			{
				name: '联系电话',
				Display: '联系电话',
				dataType: 'text',
				type: 1,
				must: true,
			},
			{
				name: '卸货仓库',
				Display: '卸货仓库',
				dataType: 'text',
				type: 1,
				must: true,
				disabled: true
			},
			{
				name: '送货地址',
				Display: '送货地址',
				dataType: 'text',
				type: 1,
				must: true,
				disabled: true
			},
			{
				name: '供应商编码',
				Display: '供应商编码',
				dataType: 'text',
				type: 1,
				must: true,
				disabled: true
			},
			{
				name: '供应商名称',
				Display: '供应商名称',
				dataType: 'text',
				type: 1,
				must: true,
				disabled: true
			}
		]
	}
}
